import ActionTypes from "../constants/ActionTypes";
import API from "../api";
import Utils from "../libs/Utils";
import i18n from "../i18n";

const requestIsLoading = () => {
    return {
        type: ActionTypes.FAQ_REQUEST
    };
};

const requestHasError = () => {
    return {
        type: ActionTypes.FAQ_FAILURE
    };
};

const getFAQByTypeSuccess = (payload) => {
    return {
        type: ActionTypes.GET_FAQ_SUCCESS,
        payload
    };
};

const addFAQSuccess = (payload) => {
    return {
        type: ActionTypes.ADD_FAQ_SUCCESS,
        payload
    };
};

const addFAQ = (data) => {
    return (dispatch) => {
        dispatch(requestIsLoading());
        API.addMetaData(data)
            .then((res) => {
                dispatch(addFAQSuccess(res.data.data));
                Utils.popupAlert({ title: i18n.t("alert.Success"), text: res.data.message, type: "success" });
            }).catch((e) => {
                dispatch(requestHasError());
                Utils.popupAlert({ title: "Oops...", text: Utils.getMessage(e), type: "error" });
            });
    };
};

const getFAQ = (data) => {
    return (dispatch) => {
        dispatch(requestIsLoading());
        API.getMetaData(data)
            .then((res) => {
                dispatch(getFAQByTypeSuccess(res.data.data));
            }).catch((e) => {
                dispatch(requestHasError());
                Utils.popupAlert({ title: "Oops...", text: Utils.getMessage(e), type: "error" });
            });
    };
};

export default {
    addFAQ,
    getFAQ
};
